"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findOutEnv = exports.findOutEnvByEnvName = exports.ENV_URLS = exports.MAIN_ENV = exports.TELCO_ENVS = exports.FAMILY_API = exports.ENV_NAME = void 0;
exports.ENV_NAME = {
    PROD: "prod",
    INTE: "inte",
    CERT: "cert",
    FARM1: "farm1",
    FARM2: "farm2",
    DEV: "dev",
    QA: "qa",
    // nuevo flujo
    LOCAL: "local",
    CODE: 'code',
    DEV_SSR: "dev_ssr",
    QA_SSR: "qa_ssr",
};
exports.FAMILY_API = {
    NAME: "name",
    HOST: "host",
    ABS_LAYER: 'abs-layer',
    CUSTO: "custo",
    GEO: "geo",
    CUSTO_STANDARD: "custo-standard",
    CATALOGUE: "catalogue",
    SSR_BACKEND: 'ssr-backend',
    TELCO: "telco",
    LEGADONOVCM: "legadoNoVCM",
    BUCKET: "bucket",
    ORION: "orion",
    SEGUROS: "seguros",
    CAMPAIGN: "campaign",
};
const SSR_BACKEND_ENVS = {
    [exports.ENV_NAME.LOCAL]: {
        endpoint: "127.0.0.1:8080",
        headers: {},
    },
    [exports.ENV_NAME.CODE]: {
        endpoint: "https://dev.ssr.col.movistar.es",
        headers: { withCredentials: true },
    },
    [exports.ENV_NAME.DEV_SSR]: {
        endpoint: "https://dev.ssr.col.movistar.es",
        headers: { withCredentials: true },
    },
    [exports.ENV_NAME.QA_SSR]: {
        endpoint: "https://dev.ssr.col.movistar.es",
        headers: { withCredentials: true },
    },
    [exports.ENV_NAME.DEV]: {
        endpoint: "https://dev.ssr.col.movistar.es",
        headers: { withCredentials: true },
    },
    [exports.ENV_NAME.QA]: {
        endpoint: "https://dev.ssr.col.movistar.es",
        headers: { withCredentials: true },
    },
    [exports.ENV_NAME.PROD]: {
        endpoint: "https://ssr.col.movistar.es",
        headers: {},
    },
};
const ABS_LAYER_ENVS = {
    [exports.ENV_NAME.LOCAL]: {
        endpoint: "https://layer.col.movistar.es",
        headers: {},
    },
    [exports.ENV_NAME.CODE]: {
        endpoint: "https://layer.col.movistar.es",
        headers: {},
    },
    [exports.ENV_NAME.DEV_SSR]: {
        endpoint: "https://layer.col.movistar.es",
        headers: {},
    },
    [exports.ENV_NAME.QA_SSR]: {
        endpoint: "https://layer.qa.col.movistar.es",
        headers: {
            withCredentials: true,
        },
    },
    [exports.ENV_NAME.DEV]: {
        endpoint: "https://layer.qa.col.movistar.es",
        headers: {
            withCredentials: true,
        },
    },
    [exports.ENV_NAME.QA]: {
        endpoint: "https://layer.qa.col.movistar.es",
        headers: {
            withCredentials: true,
        },
    },
    [exports.ENV_NAME.PROD]: {
        endpoint: "https://layer.col.movistar.es",
        headers: {},
    },
};
const ORION_ENVS = {
    [exports.ENV_NAME.LOCAL]: {
        endpoint: "https://orion.col.movistar.es",
        headers: {},
    },
    [exports.ENV_NAME.CODE]: {
        endpoint: "https://orion.col.movistar.es",
        headers: {},
    },
    [exports.ENV_NAME.DEV_SSR]: {
        endpoint: "https://orion.col.movistar.es",
        headers: {},
    },
    [exports.ENV_NAME.QA_SSR]: {
        endpoint: "https://qa.orion.col.movistar.es",
        headers: {
            withCredentials: true,
        },
    },
    [exports.ENV_NAME.DEV]: {
        endpoint: "https://orion.col.movistar.es",
        headers: {},
    },
    [exports.ENV_NAME.QA]: {
        endpoint: "https://qa.orion.col.movistar.es",
        headers: {
            withCredentials: true,
        },
    },
    [exports.ENV_NAME.PROD]: {
        endpoint: "https://orion.col.movistar.es",
        headers: {},
    },
};
const BUCKET_ENVS = {
    [exports.ENV_NAME.LOCAL]: {
        endpoint: "https://prod.cms.col.movistar.es",
        headers: {},
    },
    [exports.ENV_NAME.CODE]: {
        endpoint: "https://prod.cms.col.movistar.es",
        headers: {},
    },
    [exports.ENV_NAME.DEV_SSR]: {
        endpoint: "https://prod.cms.col.movistar.es",
        headers: {},
    },
    [exports.ENV_NAME.QA_SSR]: {
        endpoint: "https://qa.cms.col.movistar.es",
        headers: {
            withCredentials: true,
        },
    },
    [exports.ENV_NAME.DEV]: {
        endpoint: "https://qa.cms.col.movistar.es",
        headers: {
            withCredentials: true,
        },
    },
    [exports.ENV_NAME.QA]: {
        endpoint: "https://qa.cms.col.movistar.es",
        headers: {
            withCredentials: true,
        },
    },
    [exports.ENV_NAME.PROD]: {
        endpoint: "https://prod.cms.col.movistar.es",
        headers: {},
    },
};
exports.TELCO_ENVS = {
    [exports.ENV_NAME.LOCAL]: {
        endpoint: "http://tehrhad5.serv.test.dc.es.telefonica:11010",
        headers: {},
    },
    [exports.ENV_NAME.DEV]: {
        endpoint: "http://tehrhad5.serv.test.dc.es.telefonica:11010",
        headers: {},
    },
    [exports.ENV_NAME.QA]: {
        endpoint: "https://www.movistar.es.cert",
        headers: {},
    },
    [exports.ENV_NAME.CODE]: {
        endpoint: "https://www.movistar.es",
        headers: {},
    },
    [exports.ENV_NAME.DEV_SSR]: {
        endpoint: "https://www.movistar.es",
        headers: {},
    },
    [exports.ENV_NAME.QA_SSR]: {
        endpoint: "https://www.movistar.es",
        headers: {},
    },
    [exports.ENV_NAME.INTE]: {
        endpoint: "https://www.movistar.es.inte",
        headers: {},
    },
    [exports.ENV_NAME.CERT]: {
        endpoint: "https://www.movistar.es.cert",
        headers: {},
    },
    [exports.ENV_NAME.FARM1]: {
        endpoint: "https://tcolgranja1.es.telefonica",
        headers: {},
    },
    [exports.ENV_NAME.FARM2]: {
        endpoint: "https://tcolgranja2.es.telefonica",
        headers: {},
    },
    [exports.ENV_NAME.PROD]: {
        endpoint: "https://www.movistar.es",
        headers: {},
    },
};
const INFO_CONTEXTO = {
    [exports.ENV_NAME.LOCAL]: {
        endpoint: "https://www.movistar.es",
        headers: {},
    },
    [exports.ENV_NAME.CODE]: {
        endpoint: "https://www.movistar.es",
        headers: {},
    },
    [exports.ENV_NAME.DEV_SSR]: {
        endpoint: "https://www.movistar.es",
        headers: {},
    },
    [exports.ENV_NAME.QA_SSR]: {
        endpoint: "https://www.movistar.es",
        headers: {},
    },
    [exports.ENV_NAME.DEV]: {
        endpoint: "https://www.movistar.es",
        headers: {},
    },
    [exports.ENV_NAME.QA]: {
        endpoint: "https://www.movistar.es.cert",
        headers: {},
    },
    [exports.ENV_NAME.PROD]: {
        endpoint: "https://www.movistar.es",
        headers: {},
    },
};
const CUSTOMIZER_CDN_ENV = {
    [exports.ENV_NAME.LOCAL]: {
        endpoint: "https://customizer.col.movistar.es",
        headers: {
            timeout: 10000,
        },
    },
    [exports.ENV_NAME.CODE]: {
        endpoint: "https://customizer.col.movistar.es",
        headers: {
            timeout: 10000,
        },
    },
    [exports.ENV_NAME.DEV_SSR]: {
        endpoint: "https://customizer.col.movistar.es",
        headers: {
            timeout: 10000,
        },
    },
    [exports.ENV_NAME.QA_SSR]: {
        endpoint: "https://qa.customizer.col.movistar.es",
        headers: {
            withCredentials: true,
        },
    },
    [exports.ENV_NAME.DEV]: {
        endpoint: "https://customizer.dev.col.movistar.es",
        headers: {},
    },
    [exports.ENV_NAME.QA]: {
        endpoint: "https://qa.customizer.col.movistar.es",
        headers: {
            withCredentials: true,
        },
    },
    [exports.ENV_NAME.PROD]: {
        endpoint: "https://customizer.col.movistar.es",
        headers: {
            timeout: 10000,
        },
    },
};
const GEO_ENVS = {
    [exports.ENV_NAME.LOCAL]: {
        endpoint: "https://geo.layer.col.movistar.es",
        headers: {
            timeout: 15000,
        },
    },
    [exports.ENV_NAME.CODE]: {
        endpoint: "https://geo.layer.col.movistar.es",
        headers: {
            timeout: 15000,
        },
    },
    [exports.ENV_NAME.DEV_SSR]: {
        endpoint: "https://geo.layer.col.movistar.es",
        headers: {
            timeout: 15000,
        },
    },
    [exports.ENV_NAME.QA_SSR]: {
        endpoint: "https://geo.layer.col.movistar.es",
        headers: {
            timeout: 15000,
        },
    },
    [exports.ENV_NAME.DEV]: {
        endpoint: "https://geo.layer.col.movistar.es",
        headers: {},
    },
    [exports.ENV_NAME.QA]: {
        endpoint: "https://geo.layer.col.movistar.es",
        headers: {},
    },
    [exports.ENV_NAME.PROD]: {
        endpoint: "https://geo.layer.col.movistar.es",
        headers: {
            timeout: 15000,
        },
    },
};
const CATALOGUE_ENVS = {
    [exports.ENV_NAME.LOCAL]: {
        endpoint: "https://catalogue.col.movistar.es",
        headers: {
            withCredentials: true,
            "content-type": "application/json",
        },
    },
    [exports.ENV_NAME.CODE]: {
        endpoint: "https://orion.dev.col.movistar.es",
        headers: {
            withCredentials: true,
            "content-type": "application/json",
        },
    },
    [exports.ENV_NAME.DEV_SSR]: {
        endpoint: "https://qa.catalogue.col.movistar.es",
        headers: {
            withCredentials: true,
        },
    },
    [exports.ENV_NAME.QA_SSR]: {
        endpoint: "https://qa.catalogue.col.movistar.es",
        headers: {
            withCredentials: true,
        },
    },
    [exports.ENV_NAME.DEV]: {
        endpoint: "https://qa.catalogue.col.movistar.es",
        headers: {
            withCredentials: true,
        },
    },
    [exports.ENV_NAME.QA]: {
        endpoint: "https://qa.catalogue.col.movistar.es",
        headers: {
            withCredentials: true,
        },
    },
    [exports.ENV_NAME.PROD]: {
        endpoint: "https://catalogue.col.movistar.es",
        headers: {
            withCredentials: true,
            "content-type": "application/json",
        },
    },
};
const SEGUROS_ENVS = {
    [exports.ENV_NAME.LOCAL]: {
        endpoint: "https://bus.telefonicaseguros.es/services/mobile-services",
        headers: {},
    },
    [exports.ENV_NAME.CODE]: {
        endpoint: "https://bus.telefonicaseguros.es/services/mobile-services",
        headers: {},
    },
    [exports.ENV_NAME.DEV_SSR]: {
        endpoint: "https://bus.telefonicaseguros.es/services/mobile-services",
        headers: {},
    },
    [exports.ENV_NAME.QA_SSR]: {
        endpoint: "https://bus.telefonicaseguros.es/services/mobile-services",
        headers: {},
    },
    [exports.ENV_NAME.DEV]: {
        endpoint: "https://buspre.telefonicaseguros.es/des/mobile-services",
        headers: {},
    },
    [exports.ENV_NAME.QA]: {
        endpoint: "https://buspre.telefonicaseguros.es/pre/mobile-services",
        headers: {},
    },
    [exports.ENV_NAME.PROD]: {
        endpoint: "https://bus.telefonicaseguros.es/services/mobile-services",
        headers: {},
    },
};
const CAMPAIGN_ENVS = {
    [exports.ENV_NAME.PROD]: {
        endpoint: "https://campaign.scx.col.movistar.es",
        headers: { "content-type": "application/json", },
    },
    [exports.ENV_NAME.QA]: {
        endpoint: "https://scx-campaign-dot-mov-dev9.ew.r.appspot.com",
        headers: { "content-type": "application/json", },
    },
};
exports.MAIN_ENV = {
    [exports.FAMILY_API.NAME]: exports.ENV_NAME.PROD,
    [exports.FAMILY_API.HOST]: "movistar.es",
    [exports.FAMILY_API.SSR_BACKEND]: SSR_BACKEND_ENVS[exports.ENV_NAME.PROD],
    [exports.FAMILY_API.ABS_LAYER]: ABS_LAYER_ENVS[exports.ENV_NAME.PROD],
    [exports.FAMILY_API.CUSTO]: CUSTOMIZER_CDN_ENV[exports.ENV_NAME.PROD],
    [exports.FAMILY_API.CUSTO_STANDARD]: CUSTOMIZER_CDN_ENV[exports.ENV_NAME.PROD],
    [exports.FAMILY_API.CATALOGUE]: CATALOGUE_ENVS[exports.ENV_NAME.PROD],
    [exports.FAMILY_API.GEO]: GEO_ENVS[exports.ENV_NAME.PROD],
    [exports.FAMILY_API.TELCO]: exports.TELCO_ENVS[exports.ENV_NAME.PROD],
    [exports.FAMILY_API.LEGADONOVCM]: INFO_CONTEXTO[exports.ENV_NAME.PROD],
    [exports.FAMILY_API.BUCKET]: BUCKET_ENVS[exports.ENV_NAME.PROD],
    [exports.FAMILY_API.ORION]: ORION_ENVS[exports.ENV_NAME.PROD],
    [exports.FAMILY_API.SEGUROS]: SEGUROS_ENVS[exports.ENV_NAME.PROD],
    [exports.FAMILY_API.CAMPAIGN]: CAMPAIGN_ENVS[exports.ENV_NAME.PROD],
};
exports.ENV_URLS = [
    {
        [exports.FAMILY_API.NAME]: exports.ENV_NAME.QA,
        [exports.FAMILY_API.HOST]: "col10mgmt.tsm.inet",
        [exports.FAMILY_API.SSR_BACKEND]: SSR_BACKEND_ENVS[exports.ENV_NAME.QA],
        [exports.FAMILY_API.CUSTO]: CUSTOMIZER_CDN_ENV[exports.ENV_NAME.QA],
        [exports.FAMILY_API.ABS_LAYER]: ABS_LAYER_ENVS[exports.ENV_NAME.QA],
        [exports.FAMILY_API.CUSTO_STANDARD]: CUSTOMIZER_CDN_ENV[exports.ENV_NAME.QA],
        [exports.FAMILY_API.CATALOGUE]: CATALOGUE_ENVS[exports.ENV_NAME.QA],
        [exports.FAMILY_API.GEO]: GEO_ENVS[exports.ENV_NAME.QA],
        [exports.FAMILY_API.TELCO]: exports.TELCO_ENVS[exports.ENV_NAME.QA],
        [exports.FAMILY_API.LEGADONOVCM]: INFO_CONTEXTO[exports.ENV_NAME.QA],
        [exports.FAMILY_API.BUCKET]: BUCKET_ENVS[exports.ENV_NAME.QA],
        [exports.FAMILY_API.ORION]: ORION_ENVS[exports.ENV_NAME.QA],
        [exports.FAMILY_API.SEGUROS]: SEGUROS_ENVS[exports.ENV_NAME.QA],
        [exports.FAMILY_API.CAMPAIGN]: CAMPAIGN_ENVS[exports.ENV_NAME.PROD],
    },
    {
        [exports.FAMILY_API.NAME]: exports.ENV_NAME.INTE,
        [exports.FAMILY_API.HOST]: "www.movistar.es.inte",
        [exports.FAMILY_API.SSR_BACKEND]: SSR_BACKEND_ENVS[exports.ENV_NAME.QA],
        [exports.FAMILY_API.CUSTO]: CUSTOMIZER_CDN_ENV[exports.ENV_NAME.QA],
        [exports.FAMILY_API.ABS_LAYER]: ABS_LAYER_ENVS[exports.ENV_NAME.QA],
        [exports.FAMILY_API.CUSTO_STANDARD]: CUSTOMIZER_CDN_ENV[exports.ENV_NAME.QA],
        [exports.FAMILY_API.CATALOGUE]: CATALOGUE_ENVS[exports.ENV_NAME.QA],
        [exports.FAMILY_API.GEO]: GEO_ENVS[exports.ENV_NAME.QA],
        [exports.FAMILY_API.TELCO]: exports.TELCO_ENVS[exports.ENV_NAME.INTE],
        [exports.FAMILY_API.LEGADONOVCM]: INFO_CONTEXTO[exports.ENV_NAME.QA],
        [exports.FAMILY_API.BUCKET]: BUCKET_ENVS[exports.ENV_NAME.QA],
        [exports.FAMILY_API.ORION]: ORION_ENVS[exports.ENV_NAME.QA],
        [exports.FAMILY_API.SEGUROS]: SEGUROS_ENVS[exports.ENV_NAME.QA],
        [exports.FAMILY_API.CAMPAIGN]: CAMPAIGN_ENVS[exports.ENV_NAME.PROD],
    },
    {
        [exports.FAMILY_API.NAME]: exports.ENV_NAME.QA,
        [exports.FAMILY_API.HOST]: "www.movistar.es.cert",
        [exports.FAMILY_API.SSR_BACKEND]: SSR_BACKEND_ENVS[exports.ENV_NAME.QA],
        [exports.FAMILY_API.CUSTO]: CUSTOMIZER_CDN_ENV[exports.ENV_NAME.QA],
        [exports.FAMILY_API.ABS_LAYER]: ABS_LAYER_ENVS[exports.ENV_NAME.QA],
        [exports.FAMILY_API.CUSTO_STANDARD]: CUSTOMIZER_CDN_ENV[exports.ENV_NAME.QA],
        [exports.FAMILY_API.GEO]: GEO_ENVS[exports.ENV_NAME.QA],
        [exports.FAMILY_API.CATALOGUE]: CATALOGUE_ENVS[exports.ENV_NAME.QA],
        [exports.FAMILY_API.TELCO]: exports.TELCO_ENVS[exports.ENV_NAME.CERT],
        [exports.FAMILY_API.LEGADONOVCM]: INFO_CONTEXTO[exports.ENV_NAME.QA],
        [exports.FAMILY_API.BUCKET]: BUCKET_ENVS[exports.ENV_NAME.QA],
        [exports.FAMILY_API.ORION]: ORION_ENVS[exports.ENV_NAME.QA],
        [exports.FAMILY_API.SEGUROS]: SEGUROS_ENVS[exports.ENV_NAME.QA],
        [exports.FAMILY_API.CAMPAIGN]: CAMPAIGN_ENVS[exports.ENV_NAME.PROD],
    },
    {
        [exports.FAMILY_API.NAME]: exports.ENV_NAME.CODE,
        [exports.FAMILY_API.HOST]: "dev.ssr.col.movistar.es",
        [exports.FAMILY_API.SSR_BACKEND]: SSR_BACKEND_ENVS[exports.ENV_NAME.PROD],
        [exports.FAMILY_API.ABS_LAYER]: ABS_LAYER_ENVS[exports.ENV_NAME.PROD],
        [exports.FAMILY_API.CUSTO]: CUSTOMIZER_CDN_ENV[exports.ENV_NAME.PROD],
        [exports.FAMILY_API.CUSTO_STANDARD]: CUSTOMIZER_CDN_ENV[exports.ENV_NAME.PROD],
        [exports.FAMILY_API.CATALOGUE]: CATALOGUE_ENVS[exports.ENV_NAME.QA],
        [exports.FAMILY_API.GEO]: GEO_ENVS[exports.ENV_NAME.PROD],
        [exports.FAMILY_API.TELCO]: exports.TELCO_ENVS[exports.ENV_NAME.CERT],
        [exports.FAMILY_API.LEGADONOVCM]: INFO_CONTEXTO[exports.ENV_NAME.PROD],
        [exports.FAMILY_API.BUCKET]: BUCKET_ENVS[exports.ENV_NAME.PROD],
        [exports.FAMILY_API.ORION]: ORION_ENVS[exports.ENV_NAME.PROD],
        [exports.FAMILY_API.SEGUROS]: SEGUROS_ENVS[exports.ENV_NAME.PROD],
        [exports.FAMILY_API.CAMPAIGN]: CAMPAIGN_ENVS[exports.ENV_NAME.PROD],
    },
    {
        [exports.FAMILY_API.NAME]: exports.ENV_NAME.DEV_SSR,
        [exports.FAMILY_API.HOST]: "movistar.es/develop",
        [exports.FAMILY_API.SSR_BACKEND]: SSR_BACKEND_ENVS[exports.ENV_NAME.QA_SSR],
        [exports.FAMILY_API.ABS_LAYER]: ABS_LAYER_ENVS[exports.ENV_NAME.PROD],
        [exports.FAMILY_API.CUSTO]: CUSTOMIZER_CDN_ENV[exports.ENV_NAME.QA_SSR],
        [exports.FAMILY_API.CUSTO_STANDARD]: CUSTOMIZER_CDN_ENV[exports.ENV_NAME.QA_SSR],
        [exports.FAMILY_API.CATALOGUE]: CATALOGUE_ENVS[exports.ENV_NAME.QA_SSR],
        [exports.FAMILY_API.GEO]: GEO_ENVS[exports.ENV_NAME.PROD],
        [exports.FAMILY_API.TELCO]: exports.TELCO_ENVS[exports.ENV_NAME.PROD],
        [exports.FAMILY_API.LEGADONOVCM]: INFO_CONTEXTO[exports.ENV_NAME.PROD],
        [exports.FAMILY_API.BUCKET]: BUCKET_ENVS[exports.ENV_NAME.QA_SSR],
        [exports.FAMILY_API.ORION]: ORION_ENVS[exports.ENV_NAME.QA_SSR],
        [exports.FAMILY_API.SEGUROS]: SEGUROS_ENVS[exports.ENV_NAME.PROD],
        [exports.FAMILY_API.CAMPAIGN]: CAMPAIGN_ENVS[exports.ENV_NAME.PROD],
    },
    {
        [exports.FAMILY_API.NAME]: exports.ENV_NAME.QA_SSR,
        [exports.FAMILY_API.HOST]: "movistar.es/qa",
        [exports.FAMILY_API.SSR_BACKEND]: SSR_BACKEND_ENVS[exports.ENV_NAME.QA_SSR],
        [exports.FAMILY_API.ABS_LAYER]: ABS_LAYER_ENVS[exports.ENV_NAME.QA_SSR],
        [exports.FAMILY_API.CUSTO]: CUSTOMIZER_CDN_ENV[exports.ENV_NAME.QA_SSR],
        [exports.FAMILY_API.CUSTO_STANDARD]: CUSTOMIZER_CDN_ENV[exports.ENV_NAME.QA_SSR],
        [exports.FAMILY_API.CATALOGUE]: CATALOGUE_ENVS[exports.ENV_NAME.QA_SSR],
        [exports.FAMILY_API.GEO]: GEO_ENVS[exports.ENV_NAME.QA_SSR],
        [exports.FAMILY_API.TELCO]: exports.TELCO_ENVS[exports.ENV_NAME.QA_SSR],
        [exports.FAMILY_API.LEGADONOVCM]: INFO_CONTEXTO[exports.ENV_NAME.QA_SSR],
        [exports.FAMILY_API.BUCKET]: BUCKET_ENVS[exports.ENV_NAME.QA_SSR],
        [exports.FAMILY_API.ORION]: ORION_ENVS[exports.ENV_NAME.QA_SSR],
        [exports.FAMILY_API.SEGUROS]: SEGUROS_ENVS[exports.ENV_NAME.QA_SSR],
        [exports.FAMILY_API.CAMPAIGN]: CAMPAIGN_ENVS[exports.ENV_NAME.PROD],
    },
    {
        [exports.FAMILY_API.NAME]: exports.ENV_NAME.QA,
        [exports.FAMILY_API.HOST]: "qa.cms.col.movistar.es",
        [exports.FAMILY_API.SSR_BACKEND]: SSR_BACKEND_ENVS[exports.ENV_NAME.QA],
        [exports.FAMILY_API.ABS_LAYER]: ABS_LAYER_ENVS[exports.ENV_NAME.QA],
        [exports.FAMILY_API.CUSTO]: CUSTOMIZER_CDN_ENV[exports.ENV_NAME.QA],
        [exports.FAMILY_API.GEO]: GEO_ENVS[exports.ENV_NAME.QA],
        [exports.FAMILY_API.CUSTO_STANDARD]: CUSTOMIZER_CDN_ENV[exports.ENV_NAME.QA],
        [exports.FAMILY_API.CATALOGUE]: CATALOGUE_ENVS[exports.ENV_NAME.QA],
        [exports.FAMILY_API.TELCO]: exports.TELCO_ENVS[exports.ENV_NAME.CERT],
        [exports.FAMILY_API.LEGADONOVCM]: INFO_CONTEXTO[exports.ENV_NAME.QA],
        [exports.FAMILY_API.BUCKET]: BUCKET_ENVS[exports.ENV_NAME.QA],
        [exports.FAMILY_API.ORION]: ORION_ENVS[exports.ENV_NAME.QA],
        [exports.FAMILY_API.SEGUROS]: SEGUROS_ENVS[exports.ENV_NAME.QA],
        [exports.FAMILY_API.CAMPAIGN]: CAMPAIGN_ENVS[exports.ENV_NAME.PROD],
    },
    {
        [exports.FAMILY_API.NAME]: exports.ENV_NAME.QA,
        [exports.FAMILY_API.HOST]: "tcolgranja1.es.telefonica",
        [exports.FAMILY_API.SSR_BACKEND]: SSR_BACKEND_ENVS[exports.ENV_NAME.QA],
        [exports.FAMILY_API.CUSTO]: CUSTOMIZER_CDN_ENV[exports.ENV_NAME.QA],
        [exports.FAMILY_API.ABS_LAYER]: ABS_LAYER_ENVS[exports.ENV_NAME.QA],
        [exports.FAMILY_API.CUSTO_STANDARD]: CUSTOMIZER_CDN_ENV[exports.ENV_NAME.QA],
        [exports.FAMILY_API.CATALOGUE]: CATALOGUE_ENVS[exports.ENV_NAME.PROD],
        [exports.FAMILY_API.GEO]: GEO_ENVS[exports.ENV_NAME.QA],
        [exports.FAMILY_API.TELCO]: exports.TELCO_ENVS.FARM1,
        [exports.FAMILY_API.LEGADONOVCM]: INFO_CONTEXTO[exports.ENV_NAME.QA],
        [exports.FAMILY_API.BUCKET]: BUCKET_ENVS[exports.ENV_NAME.QA],
        [exports.FAMILY_API.ORION]: ORION_ENVS[exports.ENV_NAME.QA],
        [exports.FAMILY_API.SEGUROS]: SEGUROS_ENVS[exports.ENV_NAME.QA],
        [exports.FAMILY_API.CAMPAIGN]: CAMPAIGN_ENVS[exports.ENV_NAME.PROD],
    },
    {
        [exports.FAMILY_API.NAME]: exports.ENV_NAME.QA,
        [exports.FAMILY_API.HOST]: "tcolgranja2.es.telefonica",
        [exports.FAMILY_API.SSR_BACKEND]: SSR_BACKEND_ENVS[exports.ENV_NAME.QA],
        [exports.FAMILY_API.ABS_LAYER]: ABS_LAYER_ENVS[exports.ENV_NAME.QA],
        [exports.FAMILY_API.CUSTO]: CUSTOMIZER_CDN_ENV[exports.ENV_NAME.QA],
        [exports.FAMILY_API.CUSTO_STANDARD]: CUSTOMIZER_CDN_ENV[exports.ENV_NAME.QA],
        [exports.FAMILY_API.CATALOGUE]: CATALOGUE_ENVS[exports.ENV_NAME.PROD],
        [exports.FAMILY_API.GEO]: GEO_ENVS[exports.ENV_NAME.QA],
        [exports.FAMILY_API.TELCO]: exports.TELCO_ENVS.FARM2,
        [exports.FAMILY_API.LEGADONOVCM]: INFO_CONTEXTO[exports.ENV_NAME.QA],
        [exports.FAMILY_API.BUCKET]: BUCKET_ENVS[exports.ENV_NAME.QA],
        [exports.FAMILY_API.ORION]: ORION_ENVS[exports.ENV_NAME.QA],
        [exports.FAMILY_API.SEGUROS]: SEGUROS_ENVS[exports.ENV_NAME.QA],
        [exports.FAMILY_API.CAMPAIGN]: CAMPAIGN_ENVS[exports.ENV_NAME.PROD],
    },
    {
        [exports.FAMILY_API.NAME]: exports.ENV_NAME.LOCAL,
        [exports.FAMILY_API.HOST]: "127.0.0.1:8089",
        [exports.FAMILY_API.SSR_BACKEND]: SSR_BACKEND_ENVS[exports.ENV_NAME.PROD],
        [exports.FAMILY_API.CUSTO]: CUSTOMIZER_CDN_ENV[exports.ENV_NAME.PROD],
        [exports.FAMILY_API.ABS_LAYER]: ABS_LAYER_ENVS[exports.ENV_NAME.QA],
        [exports.FAMILY_API.CUSTO_STANDARD]: CUSTOMIZER_CDN_ENV[exports.ENV_NAME.PROD],
        [exports.FAMILY_API.CATALOGUE]: CATALOGUE_ENVS[exports.ENV_NAME.PROD],
        [exports.FAMILY_API.GEO]: GEO_ENVS[exports.ENV_NAME.PROD],
        [exports.FAMILY_API.TELCO]: exports.TELCO_ENVS[exports.ENV_NAME.DEV],
        [exports.FAMILY_API.LEGADONOVCM]: INFO_CONTEXTO[exports.ENV_NAME.PROD],
        [exports.FAMILY_API.BUCKET]: BUCKET_ENVS[exports.ENV_NAME.PROD],
        [exports.FAMILY_API.ORION]: ORION_ENVS[exports.ENV_NAME.PROD],
        [exports.FAMILY_API.SEGUROS]: SEGUROS_ENVS[exports.ENV_NAME.PROD],
        [exports.FAMILY_API.CAMPAIGN]: CAMPAIGN_ENVS[exports.ENV_NAME.PROD],
    },
    {
        [exports.FAMILY_API.NAME]: exports.ENV_NAME.DEV,
        [exports.FAMILY_API.HOST]: "127.0.0.1",
        [exports.FAMILY_API.SSR_BACKEND]: SSR_BACKEND_ENVS[exports.ENV_NAME.PROD],
        [exports.FAMILY_API.CUSTO]: CUSTOMIZER_CDN_ENV[exports.ENV_NAME.PROD],
        [exports.FAMILY_API.ABS_LAYER]: ABS_LAYER_ENVS[exports.ENV_NAME.QA],
        [exports.FAMILY_API.CUSTO_STANDARD]: CUSTOMIZER_CDN_ENV[exports.ENV_NAME.PROD],
        [exports.FAMILY_API.CATALOGUE]: CATALOGUE_ENVS[exports.ENV_NAME.DEV],
        [exports.FAMILY_API.GEO]: GEO_ENVS[exports.ENV_NAME.QA],
        [exports.FAMILY_API.TELCO]: exports.TELCO_ENVS[exports.ENV_NAME.DEV],
        [exports.FAMILY_API.LEGADONOVCM]: INFO_CONTEXTO[exports.ENV_NAME.QA],
        [exports.FAMILY_API.BUCKET]: BUCKET_ENVS[exports.ENV_NAME.PROD],
        [exports.FAMILY_API.ORION]: ORION_ENVS[exports.ENV_NAME.DEV],
        [exports.FAMILY_API.SEGUROS]: SEGUROS_ENVS[exports.ENV_NAME.QA],
        [exports.FAMILY_API.CAMPAIGN]: CAMPAIGN_ENVS[exports.ENV_NAME.PROD],
    },
    exports.MAIN_ENV,
    {
        [exports.FAMILY_API.NAME]: exports.ENV_NAME.PROD,
        [exports.FAMILY_API.HOST]: "prod.cms.col.movistar.es",
        [exports.FAMILY_API.SSR_BACKEND]: SSR_BACKEND_ENVS[exports.ENV_NAME.PROD],
        [exports.FAMILY_API.CUSTO]: CUSTOMIZER_CDN_ENV[exports.ENV_NAME.PROD],
        [exports.FAMILY_API.ABS_LAYER]: ABS_LAYER_ENVS[exports.ENV_NAME.PROD],
        [exports.FAMILY_API.CUSTO_STANDARD]: CUSTOMIZER_CDN_ENV[exports.ENV_NAME.PROD],
        [exports.FAMILY_API.CATALOGUE]: CATALOGUE_ENVS[exports.ENV_NAME.PROD],
        [exports.FAMILY_API.GEO]: GEO_ENVS[exports.ENV_NAME.PROD],
        [exports.FAMILY_API.TELCO]: exports.TELCO_ENVS[exports.ENV_NAME.PROD],
        [exports.FAMILY_API.LEGADONOVCM]: INFO_CONTEXTO[exports.ENV_NAME.PROD],
        [exports.FAMILY_API.BUCKET]: BUCKET_ENVS[exports.ENV_NAME.PROD],
        [exports.FAMILY_API.ORION]: ORION_ENVS[exports.ENV_NAME.PROD],
        [exports.FAMILY_API.SEGUROS]: SEGUROS_ENVS[exports.ENV_NAME.PROD],
        [exports.FAMILY_API.CAMPAIGN]: CAMPAIGN_ENVS[exports.ENV_NAME.PROD],
    },
    {
        [exports.FAMILY_API.NAME]: exports.ENV_NAME.PROD,
        [exports.FAMILY_API.HOST]: "atencionalcliente.movistar.es",
        [exports.FAMILY_API.SSR_BACKEND]: SSR_BACKEND_ENVS[exports.ENV_NAME.PROD],
        [exports.FAMILY_API.CUSTO]: CUSTOMIZER_CDN_ENV[exports.ENV_NAME.PROD],
        [exports.FAMILY_API.ABS_LAYER]: ABS_LAYER_ENVS[exports.ENV_NAME.PROD],
        [exports.FAMILY_API.CUSTO_STANDARD]: CUSTOMIZER_CDN_ENV[exports.ENV_NAME.PROD],
        [exports.FAMILY_API.CATALOGUE]: CATALOGUE_ENVS[exports.ENV_NAME.PROD],
        [exports.FAMILY_API.GEO]: GEO_ENVS[exports.ENV_NAME.PROD],
        [exports.FAMILY_API.TELCO]: exports.TELCO_ENVS[exports.ENV_NAME.PROD],
        [exports.FAMILY_API.LEGADONOVCM]: INFO_CONTEXTO[exports.ENV_NAME.PROD],
        [exports.FAMILY_API.BUCKET]: BUCKET_ENVS[exports.ENV_NAME.PROD],
        [exports.FAMILY_API.ORION]: ORION_ENVS[exports.ENV_NAME.PROD],
        [exports.FAMILY_API.SEGUROS]: SEGUROS_ENVS[exports.ENV_NAME.PROD],
        [exports.FAMILY_API.CAMPAIGN]: CAMPAIGN_ENVS[exports.ENV_NAME.PROD],
    },
    {
        [exports.FAMILY_API.NAME]: exports.ENV_NAME.PROD,
        [exports.FAMILY_API.HOST]: "web.movistar.es",
        [exports.FAMILY_API.SSR_BACKEND]: SSR_BACKEND_ENVS[exports.ENV_NAME.PROD],
        [exports.FAMILY_API.CUSTO]: CUSTOMIZER_CDN_ENV[exports.ENV_NAME.PROD],
        [exports.FAMILY_API.ABS_LAYER]: ABS_LAYER_ENVS[exports.ENV_NAME.PROD],
        [exports.FAMILY_API.CUSTO_STANDARD]: CUSTOMIZER_CDN_ENV[exports.ENV_NAME.PROD],
        [exports.FAMILY_API.CATALOGUE]: CATALOGUE_ENVS[exports.ENV_NAME.PROD],
        [exports.FAMILY_API.GEO]: GEO_ENVS[exports.ENV_NAME.PROD],
        [exports.FAMILY_API.TELCO]: exports.TELCO_ENVS[exports.ENV_NAME.PROD],
        [exports.FAMILY_API.LEGADONOVCM]: INFO_CONTEXTO[exports.ENV_NAME.PROD],
        [exports.FAMILY_API.BUCKET]: BUCKET_ENVS[exports.ENV_NAME.PROD],
        [exports.FAMILY_API.ORION]: ORION_ENVS[exports.ENV_NAME.PROD],
        [exports.FAMILY_API.SEGUROS]: SEGUROS_ENVS[exports.ENV_NAME.PROD],
        [exports.FAMILY_API.CAMPAIGN]: CAMPAIGN_ENVS[exports.ENV_NAME.PROD],
    },
];
const DEFAULT_LOCATION_BY_ENV_NAME = {
    [exports.ENV_NAME.DEV]: "127.0.0.1",
    [exports.ENV_NAME.LOCAL]: "127.0.0.1:8089",
    [exports.ENV_NAME.CODE]: "dev.ssr.col.movistar.es",
    [exports.ENV_NAME.DEV_SSR]: "movistar.es/develop",
    [exports.ENV_NAME.QA_SSR]: "movistar.es/qa",
    [exports.ENV_NAME.INTE]: "www.movistar.es.inte",
    [exports.ENV_NAME.CERT]: "www.movistar.es.cert",
    [exports.ENV_NAME.QA]: "qa.cms.col.movistar.es",
    [exports.ENV_NAME.PROD]: "movistar.es",
};
const findOutEnvByEnvName = (envName) => {
    const envAuxName = envName ? envName.toLowerCase() : "";
    let selectedHost = (DEFAULT_LOCATION_BY_ENV_NAME &&
        DEFAULT_LOCATION_BY_ENV_NAME[envAuxName]) ||
        "";
    if (!selectedHost) {
        console.warn("envName no tipado");
        selectedHost = "movistar.es";
    }
    return exports.ENV_URLS.find((item) => item.host === selectedHost) || exports.MAIN_ENV;
};
exports.findOutEnvByEnvName = findOutEnvByEnvName;
const findOutEnv = (defaultHost = "movistar.es") => {
    let res = exports.ENV_URLS.find((item) => item.host === defaultHost) || exports.MAIN_ENV;
    try {
        const myUrl = document.location.href;
        const item = exports.ENV_URLS.find((envUrl) => {
            const { host } = envUrl;
            return myUrl.indexOf(host) !== -1;
        });
        if (item) {
            res = item;
        }
    }
    catch (err) {
        return res;
    }
    return res;
};
exports.findOutEnv = findOutEnv;
//# sourceMappingURL=index.js.map